<template>
  <div class="view not-found">
    <div class="title">{{ $t('404') }}</div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped lang="scss">
@use '@/styles/colors.scss';
@use '@/styles/responsive.scss';
@use '@/styles/fonts.scss';
.view {
  background: colors.$main-color;
  display: flex;
  align-items: center;
  justify-content: center;

  .title {
    font-family: fonts.$title-font;
    font-size: 128px;
    font-weight: 800;
    color: colors.$white-color;
  }
}
</style>
